import { NavLink, useNavigate } from 'react-router'
import { useAuth } from '../../auth/AuthProvider'
import { SearchBox } from '../SearchBox'
import { AdminNavLinks } from './AdminNavLinks'

/** The app's navigation: brand and search on top, pages grouped by what they're for, and who is
 * signed in at the foot. On narrow screens it's a drawer that `open` slides in. */
export function Sidebar({ open, onClose }: { open: boolean; onClose(): void }) {
	const { user, signOut } = useAuth()
	const navigate = useNavigate()
	return (
		<nav id="sidebar" className={open ? 'sidebar open' : 'sidebar'} aria-label="Main">
			<div className="sidebar-head">
				<NavLink to="/" className="brand">
					<span className="brand-mark" aria-hidden />
					StoreKeeper
				</NavLink>
				<button type="button" className="sidebar-close" aria-label="Close menu" onClick={onClose}>
					✕
				</button>
			</div>
			<SearchBox />
			<div className="nav-group">
				<NavLink to="/" end>
					Charts
				</NavLink>
				<NavLink to="/movers">Movers</NavLink>
				<NavLink to="/compare">Compare</NavLink>
			</div>
			<div className="nav-group">
				<h6>Service</h6>
				<NavLink to="/status">Status</NavLink>
			</div>
			{user?.role === 'admin' && (
				<div className="nav-group" role="group" aria-label="Admin">
					<h6 aria-hidden>Admin</h6>
					<AdminNavLinks />
				</div>
			)}
			<div className="sidebar-foot">
				<NavLink to="/account" className="truncate">
					{user?.name}
				</NavLink>
				<button
					type="button"
					onClick={async () => {
						await signOut()
						navigate('/login')
					}}
				>
					Sign out
				</button>
			</div>
		</nav>
	)
}
